interface ICnLinks {
  name: string;
  url: string;
  rel?: HTMLAnchorElement["rel"];
  target?: HTMLAnchorElement["target"];
}

export const companyLinks: ICnLinks[] = [
  {
    name: "Free Marketing Tools",
    url: "/free-tools",
  },
  {
    name: "Use Cases",
    url: "/use-cases",
  },
  {
    name: "Industries",
    url: "/industries",
  },
  {
    name: "Developers",
    url: "https://developers.commoninja.com",
  },
  {
    name: "Supported Platforms",
    url: "/platforms",
  },
  {
    name: "Solutions",
    url: "/solutions",
  },
  {
    name: "Affiliate Program",
    url: "/affiliates",
  },
  {
    name: "Status Page",
    url: "https://commonninja.statuspage.io/",
    rel: "noopener noreferrer",
    target: "_blank",
  },
  {
    name: "Website Analyzer",
    url: "/website-analyzer",
  },
  {
    name: "Blog",
    url: "/blog",
  },
];

export const support: ICnLinks[] = [
  {
    name: "Help Center",
    url: "https://help.commoninja.com/hc/en-us",
    rel: "noopener noreferrer",
    target: "_blank",
  },
  {
    name: "Community Forum",
    url: "https://community.commoninja.com/",
    rel: "noopener noreferrer",
    target: "_blank",
  },
  {
    name: "Contact Us",
    url: "/contact-us",
  },
];

export const features: ICnLinks[] = [
  { url: "/features/ai", name: "AI Editor" },
  { url: "/features/mcp", name: "MCP Server" },
  { url: "/features/design", name: "Design" },
  { url: "/features/payments", name: "Native Payments" },
  { url: "/features/analytics", name: "Analytics" },
  { url: "/features/api", name: "API" },
  { url: "/features/crm", name: "CRM" },
  { url: "/features/integrations", name: "Integrations" },
  { url: "/features/localization", name: "Localization" },
  { url: "/features/no-code-editor", name: "No-Code Editor" },
  { url: "/features/project-management", name: "Project Management" },
];

export const footerCompanyLinks: ICnLinks[] = [
  {
    name: "About Us",
    url: "/about-us",
  },
  {
    name: "Careers",
    url: "https://careers.commoninja.com",
  },
  {
    name: "Platform Features",
    url: "/features",
  },
  {
    name: "Status Page",
    url: "https://commonninja.statuspage.io/",
    rel: "noopener noreferrer",
    target: "_blank",
  },
  {
    name: "Contact Us",
    url: "/contact-us",
  },
  {
    name: "Suggest a Widget+",
    url: "https://commoninja.site/suggest-a-widget",
    rel: "noopener noreferrer",
    target: "_blank",
  },
];

export const footerResourcesLinks: ICnLinks[] = [
  {
    name: "Free Marketing Tools",
    url: "/free-tools",
  },
  {
    name: "Use Cases",
    url: "/use-cases",
  },
  {
    name: "Industries",
    url: "/industries",
  },
  {
    name: "Blog",
    url: "/blog",
  },
  {
    name: "Developers",
    url: "https://developers.commoninja.com",
    rel: "noopener noreferrer",
    target: "_blank",
  },
  {
    name: "Write for Us",
    url: "/write-for-us",
  },
  {
    name: "Alternatives",
    url: "/alternatives",
  },
  {
    name: "Solutions",
    url: "/solutions",
  },
  {
    name: "Coming Soon Widgets",
    url: "/coming-soon",
  },
  {
    name: "Built With Common Ninja",
    url: "/built-with",
  },
];

export const footerCommunityLinks: ICnLinks[] = [
  {
    name: "Help Center",
    url: "https://help.commoninja.com/hc/en-us",
    rel: "noopener noreferrer",
    target: "_blank",
  },
  {
    name: "Community Forum",
    url: "https://community.commoninja.com/",
    rel: "noopener noreferrer",
    target: "_blank",
  },
  // {
  //   name: "Feature Requests",
  //   url: "https://community.commoninja.com/",
  //   rel: "noopener noreferrer",
  //   target: "_blank",
  // },
  {
    name: "Affiliate Program",
    url: "/affiliates",
  },
  // {
  //   name: "Affiliate Resources",
  //   url: "/affiliates/resources",
  // },
  {
    name: "Partners",
    url: "https://developers.commoninja.com/docs/white-label/overview",
    rel: "noopener noreferrer",
    target: "_blank",
  },
];

export const toolsLinks: ICnLinks[] = [
  {
    name: "Bracket Maker",
    url: "https://www.bracketsninja.com/",
    // rel: "noopener noreferrer",
    target: "_blank",
  },
  {
    name: "Sports Prediction Game",
    url: "https://trofeo.live/",
    // rel: "noopener noreferrer",
    target: "_blank",
  },
  {
    name: "AI Widget & Landing Page Builder",
    url: "https://embeddable.co/",
    // rel: "noopener noreferrer",
    target: "_blank",
  },
  {
    name: "AI Product Videos & Documentation",
    url: "https://vidocu.ai/",
    // rel: "noopener noreferrer",
    target: "_blank",
  },
  {
    name: "SaaS Custom Domains",
    url: "https://domainee.dev/",
    // rel: "noopener noreferrer",
    target: "_blank",
  },
  {
    name: "Email API for AI Agents",
    url: "https://sendraven.ai/",
    // rel: "noopener noreferrer",
    target: "_blank",
  },
  {
    name: "Website Analyzer",
    url: "/website-analyzer",
  },
  {
    name: "Apps & Plugins Search Engine",
    url: "https://discover.commoninja.com/",
    rel: "noopener noreferrer",
    target: "_blank",
  },
];
